import React, {useState} from "react";
import topArrow from "../../Forexs/assets/topArrow.png";
import downArrow from "../../Forexs/assets/downArrow.png";
import green from "../../Forexs/assets/green.png";
import red from "../../Forexs/assets/red.png";
const PortalBTCWrap = () => {
  const data = [
    { title: "Long", red: false },
    { title: "short", red: true },
    { title: "short", red: true },
    { title: "short", red: false },
    { title: "short", red: false },
    { title: "short", red: true },
    { title: "short", red: true },
    { title: "short", red: false },
    { title: "short", red: false },
    { title: "short", red: true },
    { title: "short", red: false },
    { title: "short", red: true },
    { title: "short", red: false },
    { title: "short", red: true },
    { title: "short", red: false },
  ];
  return (
    <div className="pt-[8px] pb-[6px] p-[9px]   pr-[3px]   bg-main-green rounded-[10px]  ">
      <div className="h-[195px]  btcWrap overflow-y-scroll flex flex-col gap-[4px] pr-[4px]  ">
        {data.map((single, i) => (
          <div
            key={i}
            className="pl-[6px] flex items-center justify-between py-[6px] pr-[8px] gap-2 h-[24px]  bg-[#2A2D37] rounded-[4px]"
          >
            <div className="flex items-center">
              <div
                className={` w-[17px]  h-[14px]  flex justify-center items-center rounded-[2px] ${
                  single.red ? "bg-[#FB3F3F]" : "bg-main-green"
                }`}
              >
                <img
                  className="w-[7px]"
                  src={single.red ? downArrow : topArrow}
                  alt="arrow"
                />
              </div>
              <h2 className="uppercase  font-semibold text-[9px] ml-[8px]   whitespace-nowrap leading-[11px]">
                btc{" "}
                <span
                  className={`${
                    single.red ? "text-[#FB3F3F]" : "text-main-green"
                  }`}
                >
                  {single.title}
                </span>
              </h2>
            </div>
            <div className="flex items-center gap-[13px]">
              <h2 className=" text-[8px] leading-[9px] font-semibold">
                $27,482.55
              </h2>
              <img
                className="w-[40px]  "
                src={single.red ? red : green}
                alt="chart"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PortalBTCWrap;
